import { render, staticRenderFns } from "./TrackersBatch.vue?vue&type=template&id=422c80e5"
import script from "./TrackersBatch.vue?vue&type=script&lang=js"
export * from "./TrackersBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports